import * as React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { colors } from "../../../../utils";

const StyledTextField = styled(TextField)(({ theme }) => ({
  height: 40,
  width: "100%",
  marginLeft: "5px",
  backgroundColor: colors.white,
  "& .MuiInputBase-input": {
    color: "#212529 !important"
  },
  "& .MuiInputBase-root": {
    height: "100%",
    fontSize: "16px",
    lineHeight: "24px",
    fontFamily: "DM Sans, sans-serif",
    color: "#212529"
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "transparent",
      borderRadius: 5,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default function MuiSearchField({
  placeholder = "",
  showIcon = true,
  iconPosition = "start",
  value = "",
  handleChange = () => {},
  sx = {},
  ...rest
}) {
  return (
    <StyledTextField
      placeholder={placeholder}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      sx={sx}
      InputProps={{
        startAdornment: showIcon ? (
          <InputAdornment position={iconPosition}>
            <SearchIcon />
          </InputAdornment>
        ) : null,
      }}
      {...rest}
    />
  );
}
